import React from "react";

type AnimalType = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13;

type AnimalPlaceholder = {
  src?: string;
  animalType: AnimalType;
  alt?: string;
};

const animalImages: Record<AnimalType, string> = {
  1: "/animals/jackrussel.png", // Hund
  2: "/animals/cat.png", // Katze
  3: "/animals/rabbit.png", // Kaninchen
  4: "/animals/hamster.png", // Hamster
  5: "/animals/guinea-pig.png", // Meerschweinchen
  6: "/animals/mouse.png", // Maus
  7: "/animals/parrot.png", // Papagei
  8: "/animals/snake.png", // Schlange
  9: "/animals/turtle.png", // Schildkröte
  10: "/animals/fish.png", // Fisch
  11: "/animals/horse.png", // Pferd
  12: "/animals/sheep.png", // Schaf
  13: "/animals/cow.png", // Kuh
};

const AnimalPlaceholder: React.FC<AnimalPlaceholder> = ({
  src,
  animalType,
  alt = "Tierbild",
}) => {
  const placeholderSrc = animalImages[animalType] || "/animals/default.png"; // Default image if type is not found
  return <img src={src || placeholderSrc} alt={alt} className="rounded-md" />;
};

export default AnimalPlaceholder;
